import { ready } from './vendor/brei-project-utils.js';

import { mfo } from './modules/meet-our-farmer-owners';
import { tbd } from './modules/the-best-dairy';

const home = {
	init() {
		mfo.init();
		tbd.init();		
	}
};

ready(function () {
	home.init();
});
